import { Icon } from '@volvo-cars/react-icons';

const SmallInfoNoticeBlock: React.FC<{ children: string }> = ({ children }) => (
  <div className="flex items-center gap-8">
    <Icon icon="info-circled" size={16} color="secondary" />
    <p className="micro text-secondary">{children}</p>
  </div>
);

export default SmallInfoNoticeBlock;
